import { useSetting } from '../../../util/useSetting';
import { useState } from 'react';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

export default function RenderASection({ section, sectionIndex, scrollIdPrevix, handleUrlClickRecord }) {
    const { fontSize } = useSetting();
    const [isEnlargedURL, setIsEnlargedURL] = useState('');
    return (
        <div id={`${scrollIdPrevix}_${sectionIndex}`} className={`flex flex-col items-center justify-start gap-[16px] w-full  py-[${section.paddingVertical || '16px'}] ${section.marginTop ? `mt-[${section.marginTop}]` : ''}`} style={section.backgroundImage ? { backgroundImage: `url(${section.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: section.backgroundColor || 'transparent' } : { backgroundColor: section.backgroundColor || 'transparent' }}>
            {section?.contents?.map((content, contentIndex) => (
                <div key={contentIndex} className='text-black w-full flex items-center justify-center'>
                    {content.type === '圖片' ?
                        <img className={`px-[32px] ${content.enableEnlarge?'cursor-pointer':''}`} src={content.url} alt=''  onClick={() => { if(content.enableEnlarge) setIsEnlargedURL(content.url) }} />
                        : content.type === '標題' ?
                            <div className='text-black font-bold text-center w-[90%] px-[32px]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                            : content.type === '文字' ?
                                <div className={`px-[32px] py-[${(section.paddingVertical||content.paddingVertical) === '0px' ? '0px' : '8px'}] text-justify flex flex-col items-center justify-center font-[400] w-full`} dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                : content.type === '文字-背景圖像' ?
                                    <div className='text-justify flex flex-col items-center justify-center font-[400] w-full py-[16px] px-[32px]' style={content.backgroundImage ? { backgroundImage: `url(${content.backgroundImage})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', backgroundColor: content.backgroundColor || 'transparent' } : { backgroundColor: content.backgroundColor || 'transparent' }} dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                    : content.type === 'tabs' ?
                                        <RenderTabs content={content} />
                                        : content.type === '文字-彈出視窗' ?
                                            <RenderPopup content={content} />
                                            : content.type === '網址' ?
                                                <div className={`w-full text-left font-[400] px-[32px] py-[${section.paddingVertical === '0px' ? '0px' : '8px'}]`} >
                                                    <a onClick={()=>{if(content.url&&handleUrlClickRecord){handleUrlClickRecord(content.url)}}} href={content.url || ''} target="_blank" rel="noopener noreferrer" className={``} dangerouslySetInnerHTML={{ __html: content.text }}></a>
                                                </div>
                                                : content.type
                    }
                </div>
            ))}
            {isEnlargedURL && (
                <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50' onClick={() => setIsEnlargedURL('')}>
                    <img src={isEnlargedURL} alt='' className='max-w-full max-h-full' />
                </div>
            )}
        </div>
    )
}

function RenderPopup({ content }) {
    const { fontSize } = useSetting();
    const [isPopup1Visible, setIsPopup1Visible] = useState(false);

    const [isPopup2Visible, setIsPopup2Visible] = useState(false);
    const togglePopup2 = () => {
        setIsPopup2Visible(!isPopup2Visible);
        setIsPopup1Visible(false);
    }
    const togglePopup1 = () => {
        setIsPopup1Visible(!isPopup1Visible);
        setIsPopup2Visible(false);
    }
    return (
        <div className='relative text-justify flex flex-col items-center justify-center font-[400] w-full py-[16px] px-[32px]' style={content.backgroundImage ? { backgroundImage: `url(${content.backgroundImage})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', backgroundColor: content.backgroundColor || 'transparent' } : { backgroundColor: content.backgroundColor || 'transparent' }}>
            <div>
                <div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: content.text1 }}></div>
                <button className='inline underline text-[#0000FF] cursor-pointer' onClick={togglePopup1} dangerouslySetInnerHTML={{ __html: content.popupText1 }}></button>
                <div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: content.text2 }}></div>
                <button className='inline underline text-[#0000FF] cursor-pointer' onClick={togglePopup2} dangerouslySetInnerHTML={{ __html: content.popupText2 }}></button>
                <div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: content.text3 }}></div>
            </div>
            {isPopup1Visible && (
                <div className='absolute left-[5%] w-[90%] bg-white p-[24px] rounded-[8px] z-[1] flex flex-row justify-between items-start gap-[8px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.4)' }}>
                    <div className='flex-1' dangerouslySetInnerHTML={{ __html: content.popup1 }}></div>
                    <button className='w-[18px] h-[18px]' onClick={togglePopup1}>
                        <img src='/secondary/tasks/cross.png' alt='Close' className='w-full h-full' />
                    </button>
                </div>
            )}
            {isPopup2Visible && (
                <div className='absolute left-[5%] w-[90%] bg-white p-[24px] rounded-[8px] z-[1] flex flex-row justify-between items-start gap-[8px]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.4)' }}>
                    <div className='flex-1' dangerouslySetInnerHTML={{ __html: content.popup2 }}></div>
                    <button className='w-[18px] h-[18px]' onClick={togglePopup2}>
                        <img src='/secondary/tasks/cross.png' alt='Close' className='w-full h-full' />
                    </button>
                </div>
            )}
        </div>
    )
}

function RenderTabs({ content }) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col py-[16px]'>
            <div className='w-full flex flex-row justify-start gap-[8px] px-[16px] font-[900] bg-[#EEF2F6] pt-[8px]'>
                {content.tabs?.map((tab, ti) => (

                    <button
                        key={ti}
                        className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                        style={selectedTabIndex === ti ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                        onClick={() => { setSelectedTabIndex(ti) }}
                    >
                        {tab.name}
                    </button>
                ))}
            </div>
            <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', gap: 6, padding: 6 }}>
                <div className='cursor-pointer'>
                    <PreviousSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <NextSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <ReloadSvg height={30} width={30} />
                </div>
                <div className='flex-1'>
                    <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={content?.tabs?.[selectedTabIndex]?.url ?? 'https://task.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
                </div>
            </div>
            <div className='w-full flex flex-col overflow-auto flex-1 bg-white'>
                {content?.tabs?.[selectedTabIndex]?.contents?.map((content, ci) => (
                    <div key={ci}>
                        {content.type === '圖片' ?
                            <img className='w-full' src={content.url} alt='' />
                            : content.type === '標題' ?
                                <div className='text-black font-bold text-center w-[90%]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                                : content.type === '文字' ?
                                    <div className='text-justify flex flex-col items-center justify-center font-[400]' dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                    : content.type
                        }
                    </div>
                ))}

            </div>
        </div>
    )
}